import request from '@/utils/request'

// 获取点位设备列表
export const getDeviceList = (data) => {
    return request({
        url: '/heating/device/lists',
        params: data
    })
}

// 设备点位信息-修改
export const editDeviceInfo = (data) => {
    return request({
        url: '/heating/device/manage',
        method: 'PUT',
        data
    })
}

// 设备点位-添加
export const addIMEI = (data) => {
    return request({
        url: '/heating/device/add_IMEI',
        method: 'POST',
        data
    })
}

// 设备点位-删除
export const deleteDevice = (id) => {
    return request({
        url: `/heating/device/${id}`,
        method: 'DELETE'
    })
}

// 设备点位-批量删除
export const batchDeleteDevice = (data) => {
    return request({
        url: '/heating/device/batch_delete',
        method: 'POST',
        data
    })
}

/**
 * 批量处理
 * batch_update_order 更新排序
 * batch_enable 批量启用
 * batch_disable 批量禁用
 * batch_display 批量显示
 * batch_hidden 批量隐藏
 */
export const batchPatch = (method, data) => {
    return request({
        url: '/camera/manage',
        method: 'PATCH',
        data: {
            method,
            data
        }
    })
}

// 温采、管道 批量修改设备参数
export const batchPatchParams = (data) => {
    return request({
        url: '/heating/device/batch_setting',
        method: 'POST',
        data
    })
}
// 阀门 批量修改设备参数
export const batchPatchValveParams = (data) => {
    return request({
        url: '/heating/device/valve_setting',
        method: 'POST',
        data
    })
}

// 设置离线判定时间
export const getOfflineTime = (data) => {
    return request({
        url: '/heating/setting/detail',
        method: 'GET',
        params: data
    })
}
export const setOfflineTime = (data) => {
    return request({
        url: '/heating/setting/manage',
        method: 'POST',
        data
    })
}

// 设备升级
export const devicesUpgrade = (data) => {
    return request({
        url: '/heating/device/upgrade',
        method: 'POST',
        data
    })
}
